import { createContext } from "react"

export const GeoLocationContext = createContext()
